import React from 'react'

import '../styles/legacy/animations/pulsate.scss'
import '../styles/legacy/banner.scss'
import '../styles/legacy/demo.scss'
import '../styles/legacy/documents.scss'
import '../styles/legacy/downloads.scss'
import '../styles/legacy/features.scss'
import '../styles/legacy/flex-beat.scss'
import '../styles/legacy/global-legacy.scss'
import '../styles/legacy/instrumentsAndEffects.scss'
import '../styles/legacy/overview.scss'
import '../styles/legacy/product.scss'
import '../styles/legacy/requirements.scss'
import '../styles/legacy/ring-the-alarm.scss'
import '../styles/legacy/sectionHeader.scss'
import '../styles/legacy/sprite.scss'
import '../styles/legacy/video.scss'
import '../styles/legacy/creative-fx-plus.scss'

export default function LegacyContent({ product }) {
    const { rawHTMLContent } = product
    if (rawHTMLContent) return (
        <div
            className='bg-light'
            dangerouslySetInnerHTML={{ __html: rawHTMLContent }}
        />
    )
}
